import { inject, Injectable } from '@angular/core';
import { Offer } from '../offers/offer.model';
import { BehaviorSubject, Observable } from 'rxjs';
import { ToastsService } from '../toasts/toasts.service';

@Injectable({
	providedIn: 'root',
})
export class FavoritesService {
	private readonly toastsService = inject(ToastsService);

	constructor() {
		this.load();
	}

	private _favorites$: BehaviorSubject<Offer[]> = new BehaviorSubject<Offer[]>([]);

	get favorites$(): Observable<Offer[]> {
		return this._favorites$.asObservable();
	}

	private _shared$: BehaviorSubject<Offer[]> = new BehaviorSubject<Offer[]>([]);

	get shared$(): Observable<Offer[]> {
		return this._shared$.asObservable();
	}

	add(offer: Offer) {
		const list = [...this._favorites$.value, this.minimizeOffer(offer)];
		this._favorites$.next(list);
		this.save();
		this.toastsService.success('TOAST.SUCCESS', 'TOAST.ADDED_TO_FAVORITES');
	}

	remove(offer: Offer) {
		const list = this._favorites$.value.filter((o) => o.id !== offer.id);
		this._favorites$.next(list);
		this.save();
		this.toastsService.success('TOAST.SUCCESS', 'TOAST.REMOVED_FROM_FAVORITES');
	}

	setShared(offers: Offer[]) {
		this._shared$.next(offers);
	}

	private load() {
		const data = localStorage.getItem('favorites');

		if (data) {
			try {
				const list = JSON.parse(data);
				this._favorites$.next(list);
			} catch {
				localStorage.removeItem('favorites');
			}
		}
	}

	private minimizeOffer(offer: Offer): any {
		return {
			id: offer.id,
			accommodationPriceType: offer.accommodationPriceType,
			city: offer.city,
			name: offer.name,
			poster: offer.poster,
			price: offer.price,
			priceOffseason: offer.priceOffseason,
			pricePeakseason: offer.pricePeakseason,
			pricePublished: offer.pricePublished,
			promodescription: offer.promodescription,
			province: offer.province,
			subtype: offer.subtype,
			type: offer.type,
		};
	}

	private save() {
		const list = this._favorites$.value;
		const data = JSON.stringify(list);
		localStorage.setItem('favorites', data);
	}
}
